import { render, staticRenderFns } from "./contentCourseLectureOtherFile.vue?vue&type=template&id=e284fdba&"
import script from "./contentCourseLectureOtherFile.vue?vue&type=script&lang=js&"
export * from "./contentCourseLectureOtherFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports